/**
 * Warms the lazy chunk for a /templates/:templateId/* sub-route on
 * sidebar hover so the click-then-navigate sequence skips the
 * chunk-download wait.
 *
 * Specifiers below MUST match App.tsx's `lazy(() => import(...))` strings
 * byte-for-byte — Vite/Rollup keys chunk identity off the specifier.
 *
 * Sidebar-scoped: only top-level template sections are registered.
 */

const REGISTRY: Record<string, () => Promise<unknown>> = {
  general: () => import("@/pages/templates/template/TemplateGeneralPage"),
  dashboard: () => import("@/pages/templates/template/TemplateDashboardPage"),
  website: () => import("@/pages/templates/template/TemplateWebsitePage"),
  fields: () => import("@/pages/templates/template/TemplateFieldsPage"),
  devices: () => import("@/pages/templates/template/TemplateDevicesPage"),
  slotting: () => import("@/pages/templates/template/TemplateSlottingPage"),
  seating: () => import("@/pages/templates/template/TemplateSeatingPage"),
  workflows: () => import("@/pages/templates/template/TemplateWorkflowsPage"),
  email: () => import("@/pages/templates/template/TemplateEmailPage"),
  documents: () => import("@/pages/templates/template/TemplateDocumentsPage"),
  sender: () => import("@/pages/templates/template/TemplateSenderPage"),
  attachments: () => import("@/pages/templates/template/TemplateAttachmentsPage"),
  rules: () => import("@/pages/templates/template/TemplateRulesPage"),
  goals: () => import("@/pages/templates/template/TemplateGoalsPage"),
  "guest-import": () =>
    import("@/pages/templates/template/TemplateGuestImportPage"),
  collaborators: () =>
    import("@/pages/templates/template/TemplateCollaboratorsPage"),
  plugins: () => import("@/pages/templates/template/TemplatePluginsPage"),
};

export function prefetchTemplateRoute(url: string): void {
  const match = url.match(/^\/templates\/[^/]+\/([^/]+)/);
  if (!match) return;
  const loader = REGISTRY[match[1]];
  if (!loader) return;
  loader().catch(() => {});
}

const COMMON_ROUTES = ["general", "dashboard", "slotting"];

export function warmCommonTemplateRoutes(): void {
  for (const key of COMMON_ROUTES) {
    REGISTRY[key]?.().catch(() => {});
  }
}
